import React, { useRef, useState } from 'react';
import useFocus from '@/_hooks/useFocus';
import clsx from 'clsx';
import i18n from '@i18n';
import DeleteIcon from '@/icons/DeleteIcon';
import SearchIcon from '@/icons/SearchIcon';

export const SavedTicketsSearchBar = ({ onQueryChange, query }) => {
    const ref = useRef(null);
    const focused = useFocus(ref);
    const [inputError, setInputError] = useState(false);
    const handleBlur = () => setInputError(false);

    const handleKeyDown = e => {
        if (e.keyCode === 13 && query === '') {
            setInputError(true);
        }
    };

    const handleQuery = () => {
        setInputError(false);
    };

    return (
        <div
            className={clsx('saved-tickets-search', {
                active: focused,
                error: inputError
            })}
        >
            <input
                type="search"
                placeholder={i18n('ticketus.ticketNumber')}
                name="query"
                value={query}
                onChange={e => handleQuery(onQueryChange(e.target.value))}
                autoComplete="off"
                ref={ref}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
            />
            <SearchIcon />
            {query && (
                <button type="button" className="clear-button" onClick={() => onQueryChange('')}>
                    <div>
                        <DeleteIcon fill="#fff" opacity={1} height={8} width={8} />
                    </div>
                </button>
            )}
        </div>
    );
};
